import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const modelStateSeted = atom<boolean>({
    key: 'modelStateSeted',
    default: false,
});

export const useModelStateSetedValue = () => useRecoilValue(modelStateSeted);
export const useModelStateSetedSetState = () => useSetRecoilState(modelStateSeted);
